import React, { useState, useEffect } from 'react';
import { Phone, Mail, MessageCircle } from 'lucide-react';

const StickyContactBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      setIsVisible(window.pageYOffset > 600);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCall = () => {
    window.location.href = 'tel:+919674876102';
  };

  const handleEmail = () => {
    window.location.href = 'mailto:prnetcom.in@gmail.com';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919674876102?text=Hi, I am interested in your IT services', '_blank');
  };

  return (
    <div className={`sticky-contact-bar ${isVisible ? 'visible' : ''}`}>
      <button onClick={handleCall} className="contact-bar-btn call" data-testid="sticky-call">
        <Phone size={18} />
        <span>Call</span>
      </button>
      <button onClick={handleWhatsApp} className="contact-bar-btn whatsapp" data-testid="sticky-whatsapp">
        <MessageCircle size={18} />
        <span>WhatsApp</span>
      </button>
      <button onClick={handleEmail} className="contact-bar-btn email" data-testid="sticky-email">
        <Mail size={18} />
        <span>Email</span>
      </button>
    </div>
  );
};

export default StickyContactBar;
